import Cookies from 'js-cookie';
import get from 'lodash/get';
import * as Sentry from '@sentry/vue';
// import { axiosClient } from '~/common/js/axios';
import { breakDownHostUrl } from '~/frontend-shared/helper/util';
import { axiosClient } from '~/common/js/axios';

/**
 * next 的 shared 中 没有FuturesVersion 和 CookieKey
 */
const enum FuturesVersion {
	V1 = 1,
	V2 = 2,
  }
  
const CookieKey = 'futuresVersion';
/**
 * Cookies的维护值
 */
export const COOKIE_NAME = {
	/** @deprecated */
	TOKEN: 'accessToken',
	SALT: 'accessSalt',
	APP_TOKEN: 'accessKey',
	TOKEN_AT: 'tokenAt',
	USER_NAME: 'userName',
	MOCK_TOKEN: 'mockToken',
	RENEWING: 'renewing'
};

interface ILoginData {
	accessSalt: string;
	expiresAt?: number;
}

const getCookieOptions = (expires: Date | number) => {
	const cookieOptions = {
		expires: expires,
		sameSite: 'Lax',
		secure: process.env.NODE_ENV === 'production',
	} as Cookies.CookieAttributes;
	const webDomain = breakDownHostUrl(location.hostname);

	if (!webDomain.includes('localhost')&&!(/BitMart/).test(navigator?.userAgent)) {
		Object.assign(cookieOptions, {
			domain: webDomain,
		});
	}
	return cookieOptions;
};
const EXPIRES_TIME = 0.5 * 24 * 60 * 60 * 1000; // 0.5 Days
export const setLoginInfo = (loginData: ILoginData) => {
	if (!process.client || !loginData) {
		return;
	}
	const accessSalt = get(loginData, 'accessSalt');
	const expiresAt = get(loginData, 'expiresAt', Date.now() + EXPIRES_TIME);
	let expires = new Date(expiresAt);
	const cookieOptions = getCookieOptions(expires);
	Cookies.set('accessSalt', accessSalt, cookieOptions);
	// Cookies.set('accessToken', get(loginData, 'accessToken', ''), cookieOptions); // TODO 3619 remove

	Cookies.set('tokenAt', `${expiresAt}`, cookieOptions);
	localStorage.setItem('tokenAt', `${Date.now()}`); // TODO 兼容老版本 后续稳定后删除
};

export const removeLoginInfo = () => {
	if (!process.client) {
		return;
	}
	const cookieOptions = {
		domain: getCookieOptions(0).domain
	};
	Cookies.remove('userName');
	Cookies.remove('accessKey');
	Cookies.remove('accessToken');
	Cookies.remove('accessSalt');
	Cookies.remove('zendeskUserData');
	Cookies.remove('api_key');
	Cookies.remove('token');
	Cookies.remove('expired_ts');
	Cookies.remove('tokenAt');
	Cookies.remove(CookieKey);
	Cookies.remove('hideFuturesSwitchNotice');
	Cookies.remove('hasDelegation');
  	Cookies.remove('delegationType');
  	Cookies.remove('delegationTypeList');

	Cookies.remove('userName', cookieOptions);
	Cookies.remove('accessKey', cookieOptions);
	Cookies.remove('accessToken', cookieOptions);
	Cookies.remove('accessSalt', cookieOptions);
	Cookies.remove('zendeskUserData', cookieOptions);
	Cookies.remove('api_key', cookieOptions);
	Cookies.remove('token', cookieOptions);
	Cookies.remove('expired_ts', cookieOptions);
	Cookies.remove('tokenAt', cookieOptions);
	Cookies.remove(CookieKey, cookieOptions);
	Cookies.remove('hideFuturesSwitchNotice', cookieOptions);
	Cookies.remove('hasDelegation', cookieOptions);
	Cookies.remove('delegationType', cookieOptions);
	Cookies.remove('delegationTypeList', cookieOptions)  

	localStorage.removeItem('tokenAt'); // TODO 兼容老版本 后续稳定后删除
};

interface ILoginAppData {
	accessToken: string;
	accessSalt: string;
	futuresVersion: string;
	userAgent: string;
	deviceID: string;
	client: string;
	expiresAt?: number;
}

export const setLoginInfoInApp = (loginData: ILoginAppData) => {
	if (!process.client || !loginData) {
		return;
	}
	// 获取app的信息
	const accessToken = get(loginData, 'accessToken');
	const accessSalt = get(loginData, 'accessSalt');
	const expiresAt = get(loginData, 'expiresAt', Date.now() + 7 * 24 * 60 * 60 * 1000);
	const expires = new Date(expiresAt);
	const cookieOptions = getCookieOptions(expires);
	const webDomain = breakDownHostUrl(location.hostname);
	if ((/BitMart/).test(navigator?.userAgent)) {
		Cookies.remove('accessSalt', {
			domain: `.${webDomain}`,
		});
		Cookies.remove(COOKIE_NAME.APP_TOKEN, {
			domain: `.${webDomain}`,
		});
	}
	Cookies.remove('accessSalt');
	Cookies.remove(COOKIE_NAME.APP_TOKEN);
	Cookies.set('accessSalt', accessSalt, cookieOptions);
	// Cookies.set('tokenAt', `${expiresAt}`, cookieOptions);
	Cookies.set(COOKIE_NAME.APP_TOKEN, accessToken || '', cookieOptions);

	// const futuresVersion = +loginData.futuresVersion === FuturesVersion.V1 ? FuturesVersion.V1 : FuturesVersion.V2;

	// if (futuresVersion === FuturesVersion.V1) {
	// 	Cookies.set(CookieKey, String(futuresVersion), cookieOptions);
	// }

	const matchedResult = (loginData.userAgent || '').match(/BitMart\/(\S*) \(/);
	const version = matchedResult && Array.isArray(matchedResult) ? matchedResult[1] : '';
	// 更新
	Sentry.setContext('AppInfo', {
		deviceID: loginData.deviceID,
		client: loginData.client,
		userAgent: loginData.userAgent,
		version,
	});
};

export enum ScopeEnum  {
	// eslint-disable-next-line no-unused-vars
	WS =  'websocket',
	// eslint-disable-next-line no-unused-vars
	RESOURCE = 'dynamic_resource'
}
let handleList: { scope: ScopeEnum, handle: Promise<any> }[] = []; // 请求列表
export const getScopeToken = (scope: ScopeEnum) => {
	// 防止重复请求
	const handleRequest = (scope: ScopeEnum) => {
		const sameHandle = handleList.find(
			(item) => item.scope === scope
		);
		if (sameHandle) {
			// 遇到相同请求直接返回之前请求的promise
			// console.log('===== duplicate requests ====');
			return sameHandle.handle;
		}
		const handle = new Promise((resolve, reject) => {
			axiosClient({
				url: '/gw-api/gateway/token/scoped/create',
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				data: { scope }
			}).then((res: any) => {
				if (res?.success) {
					resolve(res.data.accessToken);
				} else {
					reject(res);
				}
			}).catch((err) => {
				reject(err);
			}).finally(() => {
				// 无论请求结果如果，都需要把对应的请求移除掉
				handleList = handleList.filter(
					(item) =>
						item.scope !== scope
				);
			});
		});
		handleList.push({ scope, handle });
		return handle;
	};

	return handleRequest(scope);
};


